import React, { createContext, PureComponent } from "react";
export const SurveyContext = createContext();

class SurveyContextProvider extends PureComponent {
  state = {
    showHeaderLogo: false,

    survey: null,
    showSurvey: false,
    isLoading: true,
    error: false,
    showNav: true,
    showSplash: false,

    currentChapterNumber: 1,

    //CHAPTER ONE
    chapterOneProgress: 0,

    //CHAPTER TWO
    chapterTwoProgress: 0,

    //CHAPTER TREE
    chapterThreeProgress: 0,

    //CHAPTER FOUR
    chapterFourProgress: 0,

    markedForLater: [],

    accessToken: null,
    userProfile: null,
    macallanWhiskies: [],
    recommendations: [],
    recommendationsLang: "",

    consumerId: "",
    storedData: null,
    vizAnimated: false,
    dialogOpen: false,
  };

  setHeaderLogoVisible = (payload) => {
    this.setState({ showHeaderLogo: payload });
  };

  setError = (status) => {
    this.setState({ error: status });
  };

  toggleSurvey = (payload) => {
    this.setState({ showSurvey: payload, showNav: !payload });
  };

  setLoader = (payload) => {
    this.setState({ isLoading: payload });
    //this.setState({ showNav: false });
  };

  setSplash = (payload) => {
    this.setState({ showSplash: payload });
  };

  //CURRENT CHAPTER
  setChapterProgress = (chapter, payload) => {
    switch (chapter) {
      case 1:
        this.setState({ chapterOneProgress: payload });
        break;
      case 2:
        this.setState({ chapterTwoProgress: payload });
        break;
      case 3:
        this.setState({ chapterThreeProgress: payload });
        break;
      case 4:
        this.setState({ chapterFourProgress: payload });
        break;
      default:
    }
  };

  setCurrentChapter = (number) => {
    this.setState({
      currentChapterNumber: number,
    });
  };

  setSurveyJs = (survey) => {
    this.setState({ survey });
  };

  replaceMarkedForLater = (markedForLater) => {
    this.setState({
      markedForLater,
    });
  };

  addMarkedForLater = (page) => {
    this.setState((prevState) => ({
      markedForLater: [...new Set([...prevState.markedForLater, page])],
    }));
  };

  removeMarkedForLater = (page) => {
    if (this.state.markedForLater.indexOf(page) === -1)
      return this.state.markedForLater;
    const newList = this.state.markedForLater.filter((item) => page !== item);
    this.setState({
      markedForLater: newList,
    });
    return newList;
  };

  setRingForming = (payload) => {
    this.setState({ isRingForming: payload });
  };

  setAccessToken = (accessToken) => {
    this.setState({ accessToken });
  };

  setUserProfile = (userProfile) => {
    this.setState({ userProfile });
  };

  setMacallanWhiskies = (macallanWhiskies) => {
    this.setState({ macallanWhiskies });
  };

  setRecommendations = (data, lang) => {
    this.setState({ recommendations: data, recommendationsLang: lang });
  };

  setConsumerId = (consumerId) => {
    this.setState({ consumerId });
  };

  setStoredData = (storedData) => {
    this.setState({ storedData });
  };

  setVizAnimated = (vizAnimated) => {
    this.setState({ vizAnimated });
  };

  setDialogOpen = (dialogOpen) => {
    // push to history to allow handling back button
    if (dialogOpen && window.location.hash !== "#exit") {
      window.history.pushState("#exit", "Exit", document.location + "#exit");
    }
    this.setState({ dialogOpen });
  };

  render() {
    return (
      <SurveyContext.Provider
        value={{
          ...this.state,
          toggleSurvey: this.toggleSurvey,
          setLoader: this.setLoader,
          setSplash: this.setSplash,
          setError: this.setError,

          setChapterProgress: this.setChapterProgress,

          setCurrentChapter: this.setCurrentChapter,
          setSurveyJs: this.setSurveyJs,

          addMarkedForLater: this.addMarkedForLater,
          removeMarkedForLater: this.removeMarkedForLater,
          replaceMarkedForLater: this.replaceMarkedForLater,

          setAccessToken: this.setAccessToken,
          setUserProfile: this.setUserProfile,
          setHeaderLogoVisible: this.setHeaderLogoVisible,

          setMacallanWhiskies: this.setMacallanWhiskies,
          setRecommendations: this.setRecommendations,

          setConsumerId: this.setConsumerId,
          setStoredData: this.setStoredData,
          setVizAnimated: this.setVizAnimated,
          setDialogOpen: this.setDialogOpen,
        }}
      >
        {this.props.children}
      </SurveyContext.Provider>
    );
  }
}

export default SurveyContextProvider;
